import React from 'react'
import {connect} from 'react-redux'
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom'
import {Layout} from 'antd'

import PrivateRoute from './component/PrivateRoute'
import Login from './pages/Login'
import './config/axios'
import SAMHeader from './component/SAMHeader'
import SAMSider from './component/SAMSider'
import SAMContent from './component/SAMContent'
import MyFooter from './component/MyFooter'
import Signup from './pages/Signup'
import {userUpdateRole} from './action/user'
import {userGetRole} from './api/user'
import Works from './pages/showcase/Works'
import {
    URL_LOGIN,
    URL_SHOWCASE_ABOUT,
    URL_SHOWCASE_CONTACT,
    URL_SHOWCASE_HOME,
    URL_SHOWCASE_NEWS,
    URL_SHOWCASE_WORK_ID,
    URL_SIGNUP
} from './const'
import News from './pages/showcase/News'
import About from './pages/showcase/About'
import Contact from './pages/showcase/Contact'
import Index from './pages/showcase/Index'

import './styles/wieldy.less'
import './asset/less/App.css'
import DashboardTourModal from "./component/dashboard/DashboardTourModal";

const {Header, Footer} = Layout

@connect(
    (state) => ({
        siderWidth: state.style.siderWidth,
        loginStatus: state.user.loginStatus,
        breakPointCollapsed: state.style.onBreakpointCollapsed
    }),
    {
        userUpdateRole
    }
)
class App extends React.Component {
    componentDidMount() {
        if (this.props.hideLoader) this.props.hideLoader()
        if (this.props.loginStatus && this.props.loginStatus === true) {
            userGetRole()
                .then((response) => {
                    if (response.data.is_pending_approve) {
                        userUpdateRole({
                            role: response.data.role,
                            is_pending_approve: response.data.is_pending_approve
                        })
                    } else {
                        userUpdateRole({
                            role: response.data.role,
                            is_pending_approve: false
                        })
                    }
                })
                .catch((e) => {
                })
        }
    }

    render() {
        return (
            <Router>
                <Switch>
                    <Route path='/login/'>
                        <Login/>
                    </Route>
                    <Route path={URL_LOGIN}>
                        <Login/>
                    </Route>
                    <Route path={URL_SIGNUP}>
                        <Signup/>
                    </Route>
                    <Route path={URL_SHOWCASE_HOME} exact={true}>
                        <Index/>
                    </Route>
                    <Route path={URL_SHOWCASE_WORK_ID}>
                        <Works/>
                    </Route>
                    <Route path={URL_SHOWCASE_NEWS} exact={true}>
                        <News/>
                    </Route>
                    <Route path={URL_SHOWCASE_ABOUT} exact={true}>
                        <About/>
                    </Route>
                    <Route path={URL_SHOWCASE_CONTACT} exact={true}>
                        <Contact/>
                    </Route>
                    <PrivateRoute>
                        <Layout style={{backgroundColor: 'white'}}>
                            <Layout style={{backgroundColor: 'white'}}>
                                <SAMSider/>
                                <Layout className='site-layout' style={{
                                    marginLeft: this.props.breakPointCollapsed ? 0 : this.props.siderWidth,
                                    backgroundColor: 'white', overflowX: 'hidden'
                                }}>
                                    <SAMHeader/>
                                    <SAMContent/>
                                    <MyFooter/>
                                </Layout>
                            </Layout>
                        </Layout>
                    </PrivateRoute>
                </Switch>
            </Router>
        )
    }
}

export default App
